import { buildEventsApiUrl } from '../config/api';

export interface EventDayPollingSettings {
  participantWaitingPollMs: number;
  participantAssignedPollMs: number;
  participantActivePollMs: number;
  participantIdlePollMs: number;
  adminReadyPollMs: number;
  adminActivePollMs: number;
  adminIdlePollMs: number;
}

export interface RuntimeSettings {
  eventDayPolling: EventDayPollingSettings;
}

export const DEFAULT_RUNTIME_SETTINGS: RuntimeSettings = {
  eventDayPolling: {
    participantWaitingPollMs: 8000,
    participantAssignedPollMs: 6000,
    participantActivePollMs: 2500,
    participantIdlePollMs: 20000,
    adminReadyPollMs: 8000,
    adminActivePollMs: 2500,
    adminIdlePollMs: 15000,
  },
};

let cachedRuntimeSettings: RuntimeSettings | null = null;
let runtimeSettingsPromise: Promise<RuntimeSettings> | null = null;

const mergeRuntimeSettings = (settings: Partial<RuntimeSettings> | null | undefined): RuntimeSettings => ({
  ...DEFAULT_RUNTIME_SETTINGS,
  ...(settings || {}),
  eventDayPolling: {
    ...DEFAULT_RUNTIME_SETTINGS.eventDayPolling,
    ...((settings && settings.eventDayPolling) || {}),
  },
});

export const getRuntimeSettings = async (): Promise<RuntimeSettings> => {
  if (cachedRuntimeSettings) return cachedRuntimeSettings;
  if (!runtimeSettingsPromise) {
    runtimeSettingsPromise = fetch(buildEventsApiUrl('/api/runtime-settings'))
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Failed to load runtime settings');
        cachedRuntimeSettings = mergeRuntimeSettings(data.settings);
        return cachedRuntimeSettings;
      })
      .catch(() => {
        cachedRuntimeSettings = DEFAULT_RUNTIME_SETTINGS;
        return cachedRuntimeSettings;
      })
      .finally(() => {
        runtimeSettingsPromise = null;
      });
  }
  return runtimeSettingsPromise;
};
